import libhyphenator from "../lib/hyphenator/hyphenator.js";

const configuration = {
	enabled: true,
};

/**
 * Configuration for `hyphenator`.
 *
 * @param {boolean} [enabled] - Indicates whether
 * to hyphenate the words.
 */
export function setConfiguration({ enabled } = {}) {
	configuration.enabled = enabled;
}

export default (function () {
	const that = {};
	const my = {};

	let language = "en";
	const supportedLanguages = ["en", "sv", "fi", "no", "da"];

	that.run = function () {
		libhyphenator.run();
	};

	that.setLanguage = function (lang) {
		language = lang.slice(0, 2);
		if (supportedLanguages.indexOf(language) === -1) {
			language = "en";
		}
	};

	that.hyphenate = function (translation, lang = language) {
		if (!configuration.enabled) {
			return translation;
		}

		if (
			typeof translation === "object" &&
			translation.constructor === Array
		) {
			return deepHyphenate(translation, lang);
		} else if (typeof translation === "string") {
			return my.hyphenate(translation, lang);
		}
		return translation;
	};

	function deepHyphenate(array, lang) {
		return array.map((each) => that.hyphenate(each, lang));
	}

	my.hyphenate = function (string, lang) {
		return libhyphenator.hyphenate(string, lang);
	};

	return that;
})();
